import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6483d52e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ban-mask flex-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/ban_icon.png",
  alt: "",
  class: "ban-mask-img"
}, null, -1))
const _hoisted_3 = { class: "ban-mask-text" }
const _hoisted_4 = {
  key: 1,
  class: "ban-mask goods-mask flex-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/ban_icon2.png",
  alt: "",
  class: "ban-mask-img"
}, null, -1))
const _hoisted_6 = { class: "ban-mask-text" }
const _hoisted_7 = {
  key: 2,
  class: "ban-mask goods-mask flex-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/ban_icon2.png",
  alt: "",
  class: "ban-mask-img"
}, null, -1))
const _hoisted_9 = { class: "ban-mask-text" }

import { t } from '@/plugins/i18n'
import { computed } from 'vue'
import { codeName } from './data'

export default /*#__PURE__*/_defineComponent({
  props: {
  // detail 详情 goods 商品 shop 店铺
  type: {
    default: 'detail',
    type: String
  },
  item: {
    default: () => { return {} },
    type: Object
  }
},
  setup(__props) {

const props = __props

const errorText = computed(() => {
  return props.item?.blackTag === 1 && codeName[props.item?.blackReasonCode]?.normal
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.type === 'detail' && _unref(errorText))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(errorText)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'goods' && _unref(errorText))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(errorText)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'shop' && _unref(errorText))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(errorText)), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})